module.exports = __webpack_public_path__ + "b1d52df7c9e2b8d674cb2686e2669629.svg";